<template>
  <div class="toastContainer" v-show="isToast">
    <div class="scene s1" v-show="sShow.s1Show">
      <div class="clouds">
        <span class="lightning l1 shineIn1"></span>
        <span class="lightning l2 shineIn2"></span>
        <span class="lightning l3 shineIn3"></span>
        <span class="lightning l4 shineIn2"></span>
        <span class="c-cloud c-1 slideLeft"></span>
        <span class="c-cloud c-2 slideTop"></span>
        <span class="c-cloud c-3 slideRight"></span>
      </div>
      <notification :num="1" v-show="npShow" />
      <prompt :num="1" v-show="!npShow" @crossIt="onCrossIt" />
    </div>
    <div class="scene s2" v-show="sShow.s2Show">
      <div class="hand-wrapper">
        <img class="hw-a" src="./p2-after.png" alt="">
        <img class="hw-b" :class="isAniSlideOut ? 'slideOut' : ''" @touchstart="press" src="./p2-before.png" alt="">
      </div>
      <notification :num="2" v-show="npShow" />
      <prompt :num="2" v-show="!npShow" @crossIt="onCrossIt" />
    </div>
    <div class="scene s3" v-show="sShow.s3Show">
      <div class="plane-wrapper">
        <span class="pw-plane" :class="isAniFlyOut ? 'flyOut' : ''" @touchstart="blow"></span>
      </div>
      <notification :num="3" v-show="npShow" />
      <prompt :num="3" v-show="!npShow" @crossIt="onCrossIt" />
    </div>
    <div class="scene s4" v-show="sShow.s4Show">
      <div class="mirror-wrapper">
        <img class="mw-1" src="./p4-mirror2.png" alt="">
        <img class="mw-2" :class="isAniSlideOut ? 'slideOut' : ''" @touchstart="smooth" src="./p4-mirror.png" alt="">
      </div>
      <notification :num="4" v-show="npShow" />
      <prompt :num="4" v-show="!npShow" @crossIt="onCrossIt" />
    </div>
  </div>
</template>

<script>
import Notification from '../notification/notification';
import Prompt from '../prompt/prompt';

export default {
  name: 'Toast',
  props: {
    isToast: {
      type: Boolean
    },
    myScene: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      npShow: true,
      isAniSlideOut: false,
      isAniPressOut: false,
      isAniFlyOut: false
    }
  },
  computed: {
    sShow () {
      switch (this.myScene) {
        case 1:
          return {
            s1Show: true,
            s2Show: false,
            s3Show: false,
            s4Show: false,
          }
        case 2:
          return {
            s1Show: false,
            s2Show: true,
            s3Show: false,
            s4Show: false,
          }
        case 3:
          return {
            s1Show: false,
            s2Show: false,
            s3Show: true,
            s4Show: false,
          }
        case 4:
          return {
            s1Show: false,
            s2Show: false,
            s3Show: false,
            s4Show: true,
          }
        default:
          return {
            s1Show: true,
            s2Show: false,
            s3Show: false,
            s4Show: false,
          }
      }
    }
  },
  components: {
    Notification,
    Prompt,
  },
  methods: {
    onCrossIt () {
      this.isAniSlideOut = false;
      this.npShow = true;
      this.$emit('sendCrossIt', {sNum: this.myScene});
      console.log('cross toast');
    },
    smooth (e) {
      console.log('smooth');
      console.log(e);
      setTimeout(() => {
        this.isAniSlideOut = true;
        this.npShow = false;
      }, 1200);
    },
    press () {
      this.isAniSlideOut = true;
      this.npShow = false;
    },
    blow () {
      setTimeout(() => {
        this.isAniFlyOut = true;
        this.npShow = false;
      }, 3000);
    },
    shake () {
      const _this = this;
      const SHAKE_THRESHOLD = 200;
      let last_update = 0;
      let x, y, z, last_x = 0, last_y = 0, last_z = 0;

      function deviceMotionHandler (evt) {
        let acceleration = evt.accelerationIncludingGravity;
        let curTime = new Date().getTime();
        if ((curTime - last_update) > 100) {
          let diffTime = curTime - last_update;
          last_update = curTime;
          x = acceleration.x;
          y = acceleration.y;
          z = acceleration.z;
          let speed = Math.abs(x + y + z - last_x - last_y - last_z) / diffTime * 1000;
          if (speed > SHAKE_THRESHOLD) {
            // do what you want
            _this.npShow = false;
          }
        }
        last_x = x;
        last_y = y;
        last_z = z;
      }

      if (window.DeviceMotionEvent) {
        window.addEventListener('devicemotion', deviceMotionHandler, false);
      }
    }
  },
  mounted () {
    this.shake();
  },
}
</script>

<style lang="less" scoped>
.toastContainer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .4);
  .scene {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .s1 {
    background: linear-gradient(#010f1b, #06233b 50%, #09365b 90%);
    .clouds {
      .lightning {
        position: absolute;
        display: inline-block;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .l1 {
        top: 7.5rem /* 120/16 */;
        left: 3.75rem /* 60/16 */;
        width: 3.875rem /* 62/16 */;
        height: 10.8125rem /* 173/16 */;
        background-image: url('./p1-l1.png');
      }
      .l2 {
        top: 6.25rem /* 100/16 */;
        left: 7.625rem /* 122/16 */;
        width: 3.625rem /* 58/16 */;
        height: 10.4375rem /* 167/16 */;
        background-image: url('./p1-l2.png');
      }
      .l3 {
        top: 6.25rem /* 100/16 */;
        left: 8.875rem /* 142/16 */;
        width: 6.875rem /* 110/16 */;
        height: 16.5625rem /* 265/16 */;
        background-image: url('./p1-l3.png');
      }
      .l4 {
        top: 7.5rem /* 120/16 */;
        right: 5.5rem /* 88/16 */;
        width: 3.5625rem /* 57/16 */;
        height: 6.3125rem /* 101/16 */;
        background-image: url('./p1-l4.png');
      }
      .c-cloud {
        position: absolute;
        display: inline-block;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .c-1 {
        top: 4.375rem /* 70/16 */;
        left: 0;
        width: 8.75rem /* 140/16 */;
        height: 5.4375rem /* 87/16 */;
        background-image: url('./p1-cloud-l.png');
      }
      .c-2 {
        width: 23.4375rem /* 375/16 */;
        height: 8.125rem /* 130/16 */;
        background-image: url('./p1-cloud-main.png');
      }
      .c-3 {
        top: 6.25rem /* 100/16 */;
        right: 0;
        width: 6.25rem /* 100/16 */;
        height: 3.5rem /* 56/16 */;
        background-image: url('./p1-cloud-r.png');
      }
    }
  }
  .s2 {
    background-image: url('./p2.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    .hand-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: 0 auto;
      width: 19.6875rem /* 315/16 */;
      height: 26.5625rem /* 425/16 */;
      border-bottom-left-radius: .5rem /* 8/16 */;
      border-bottom-right-radius: .5rem /* 8/16 */;
      background: linear-gradient(#0e1443, #060f27 50%, #010b14 98%);
      img {
        width: 16.03125rem /* 256.5/16 */;
      }
      .hw-b {
        position: absolute;
      }
    }
  }
  .s3 {
    background-image: url('./p3.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    .plane-wrapper {
      position: absolute;
      top: 4.3125rem /* 69/16 */;
      left: 50%;
      transform: translateX(-7.0625rem /* 113/16 */);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14.125rem /* 226/16 */;
      height: 15.625rem /* 250/16 */;
      background-image: url('./p3-wrapper.png');
      background-size: cover;
      background-repeat: no-repeat;
      .pw-plane {
        width: 9.75rem /* 156/16 */;
        height: 7.03rem;
        margin-bottom: 7.5rem /* 120/16 */;
        background-image: url('./p3-plane.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }
  .s4 {
    position: relative;
    background-image: url('./p4.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    .mirror-wrapper {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 2.5rem /* 40/16 */;
      width: 23.375rem /* 374/16 */;
      height: 24.5rem /* 392/16 */;
      background-image: url('./p4-wrapper.png');
      background-size: cover;
      background-repeat: no-repeat;
      img {
        position: absolute;
        width: 11rem /* 176/16 */;
        transform: translate(2px, -8px);
      }
    }
  }
}

.shineIn1 {
  animation: shineIn .2s ease-in;
  animation-fill-mode: both;
  animation-delay: 1.4s;
}

.shineIn2 {
  animation: shineIn .2s ease-in;
  animation-fill-mode: both;
  animation-delay: 1.6s;
}

.shineIn3 {
  animation: shineIn .2s ease-in;
  animation-fill-mode: both;
  animation-delay: 1.8s;
}

.slideTop {
  animation: slideTop 1.2s linear;
  animation-fill-mode: both;
}

.slideLeft {
  animation: slideLeft 1s linear;
  animation-delay: .2s;
  animation-fill-mode: both;
}

.slideRight {
  animation: slideRight .6s linear;
  animation-delay: .4s;
  animation-fill-mode: both;
}


.slideOut {
  animation: slideOut 1.4s linear;
  animation-fill-mode: both;
}

.flyOut {
  animation: flyOut 1.2s ease-out;
  animation-fill-mode: both;
}

@keyframes shineIn {
  from {
    transform-origin: top;
    transform: scale(0, 0);
  }
  to {
    transform-origin: top;
    transform: scale(1, 1);
  }
}

@keyframes slideLeft {
  from {
    transform: translateX(-80px);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideRight {
  from {
    transform: translateX(80px);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideTop {
  from {
    transform: translateY(-80px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes flyOut {
  from {
    opacity: 1;
    transform: translate(0);
  }
  to {
    opacity: 0;
    transform: translate(100px, -80px);
  }
}

@keyframes slideOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
